/*
* Copyright (c) 2023 SHYFTBASE INC.
* Author: SHYFTBASE INC.
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import locales from './locales/locales'

const resources = {
  en: {
    translation:  locales.en
  },
}

i18n
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        lng: 'en',
        debug: true,
        interpolation: {
          escapeValue: false, // not needed for react as it escapes by default
        }
    })

export default i18n